import { apiClient } from '../../api/client';
import { ApiResponse, PagedResponse } from '../../api/types';
import { PoolInfo, GameRoom, GameServer, GameServerMatch, GameServerState, MatchDetail } from './types';

export async function listGameServers(
  page: number,
  perPage: number,
  status?: GameServerState,
  id?: string
): Promise<PagedResponse<GameServer>> {
  const response = await apiClient.get<PagedResponse<GameServer>>(
    '/api/v1/admin/game-servers',
    { params: { page, per_page: perPage, ...(status ? { status } : {}), ...(id ? { id } : {}) } }
  );
  return response.data;
}

export async function listGameServerMatches(
  serverID: string,
  page: number
): Promise<PagedResponse<GameServerMatch>> {
  const response = await apiClient.get<PagedResponse<GameServerMatch>>(
    `/api/v1/admin/game-servers/${encodeURIComponent(serverID)}/matches`,
    { params: { page, per_page: 10 } }
  );
  return response.data;
}

export async function getGameServerMatch(
  serverID: string,
  roomID: number,
  matchNumber: number
): Promise<MatchDetail> {
  const response = await apiClient.get<ApiResponse<MatchDetail>>(
    `/api/v1/admin/game-servers/${encodeURIComponent(serverID)}/rooms/${roomID}/matches/${matchNumber}`
  );
  return response.data.data;
}

export async function getGameServerLogs(serverID: string): Promise<string> {
  const response = await apiClient.get<string>(
    `/api/v1/admin/game-servers/${encodeURIComponent(serverID)}/logs`,
    { responseType: 'text' }
  );
  return response.data;
}

export async function listGameServerRooms(serverID: string, page: number): Promise<PagedResponse<GameRoom>> {
  const response = await apiClient.get<PagedResponse<GameRoom>>(
    `/api/v1/admin/game-servers/${encodeURIComponent(serverID)}/rooms`,
    { params: { page, per_page: 12 } }
  );
  return response.data;
}

export async function getPoolInfo(): Promise<PoolInfo> {
  const response = await apiClient.get<ApiResponse<PoolInfo>>('/api/v1/admin/game-server-pool/config');
  return response.data.data;
}

export async function deleteGameServer(serverID: string): Promise<void> {
  await apiClient.delete(
    `/api/v1/admin/game-servers/${encodeURIComponent(serverID)}`,
  );
}
